import { supabase } from '../supabase/config';

export const showUserProfilePanel = async (userId, fromPanel = null) => {
  window.userProfilePreviousPanel = fromPanel;
  try {
    const supabaseClient = window.supabase || supabase;
    const { data: userData, error } = await supabaseClient
      .from('users').select('*').eq('id', userId).single();
    if (error) throw error;

    const currentUserId = window.currentAppUser?.uid || window.currentUser?.uid;
    const isOnline = await window.getUserOnlineStatus(userId);

    // Check mute status if organizer in event context
    const currentEventId = window.currentEventId || window.currentChatEventId ||
      window.currentViewingEventId ||
      document.getElementById('chatPanel')?.dataset?.eventId ||
      document.getElementById('eventDetailsPanel')?.dataset?.eventId;

let isOrganizer = false;
    let isMuted = false;
    if (currentEventId && userId !== currentUserId) {
      const { data: event } = await supabaseClient
        .from('events').select('creator_id, muted_users, archived').eq('event_id', currentEventId).single();
      // Don't show organizer controls (mute) for archived events
      isOrganizer = event?.creator_id === currentUserId && !event?.archived;
      isMuted = (event?.muted_users || []).includes(userId);
    }

    const alreadyReported = userId !== currentUserId
      ? await window.checkAlreadyReported('user', userId)
      : false;

    window.dispatchEvent(new CustomEvent('openUserProfilePanel', {
      detail: { userId, fromPanel, userData, isOnline, isMuted, isOrganizer, currentEventId, currentUserId, alreadyReported }
    }));
  } catch (err) {
    console.error('Error fetching user data:', err);
  }
};

// Function to close user profile panel
export const closeUserProfilePanel = () => {
  window.dispatchEvent(new CustomEvent('closeUserProfilePanel'));
};

// Show user profile from chat (wrapper for showUserProfilePanel)
export const showUserProfile = async (userId) => {
  // Don't close chat - keep it open in the background
  // Just open profile on top of it
  
  // Set a flag so profile knows it was opened from chat
  window.openedFromChat = true;
  
  if (window.showUserProfilePanel) {
    await window.showUserProfilePanel(userId, 'chat');
  }
};

window.showUserProfilePanel = showUserProfilePanel;
window.closeUserProfilePanel = closeUserProfilePanel;
window.showUserProfile = showUserProfile;